/**
 * 安全培训计划
 */
import * as API from '../'

export default {
  /**
   * 安全培训计划 分页列表
   */
  queryList: params => {
    return API.GET(`/clouddo-tranning/tranning/safety_training_program/page_list`, params)
  },

  queryOfflineList: params => {
    return API.GET(`/clouddo-tranning/tranning/safety_training_program/page_offline_list`, params)
  },
  /**
   * 详情
   */
  details: params => {
    return API.GET(`/clouddo-tranning/tranning/safety_training_program/details`, params)
  },

  /**
   * 计划下拉框
   */
  options: params => {
    return API.GET(`/clouddo-tranning/tranning/safety_training_program/options`, params)
  },

  /**
   * 保存记划
   */
  save: params => {
    return API.POST(`/clouddo-tranning/tranning/safety_training_program/save`, params)
  },

  /**
   * 保存记划
   */
  del: params => {
    return API.POST(`/clouddo-tranning/tranning/safety_training_program/del`, params)
  },
}




// WEBPACK FOOTER //
// ./src/api/new/safety_raining_program.js